import React from 'react';
import useReviews from '../../hooks/useReviews';

const Reviews = () => {
    const [reviews, setReviews] = useReviews();


    return (
        <div className='container mb-5'>
            <h3 className='text-center mt-4'>What our customers say!</h3>

            <div className='row gap-3 justify-content-center'>
                {
                    reviews.map(review =>
                        <div className=' col-md-4 border-light rounded  mb-2 p-4 shadow'>
                            <img className='w-100 p-2' src={review.img} alt="" />

                            <div className='p-2'>
                                <h5>
                                    {review.name}
                                </h5>
                                <p className=''><span className='fw-bold'>Review:</span> {review.comment}</p>
                                <small><span className='fw-bold'>Ratings:</span> {review.rating}</small>
                            </div>
                        </div>
                    )
                }
            </div>
        </div>


    );
};

export default Reviews;